import { webApi } from "../../../../core/http/httpThunks";
import { Commission } from "../types";

export const getAllCommisionsApi = (userId: string) =>
	webApi<Commission[]>({
		method: "GET",
		url: "listing/getcommlist",
		params: {
			userId,
		},
	});

export default getAllCommisionsApi;
